import React from 'react';
import { makeStore, useStore } from 'statery';

var createStateMachine = function createStateMachine(initialState) {
  var store = makeStore({
    state: initialState
  });
  var matchesState = function matchesState(state, other) {
    return Array.isArray(other) ? other.includes(state) : state === other;
  };
  var Match = function Match(_ref) {
    var state = _ref.state,
      children = _ref.children;
    var _useStore = useStore(store),
      currentState = _useStore.state;
    return matchesState(currentState, state) ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
  };
  var enter = function enter(state) {
    var currentState = store.state.state;
    if (state && state !== currentState) {
      store.set({
        state: state
      });
    }
  };
  var is = function is(state) {
    return matchesState(store.state.state, state);
  };
  return {
    Match: Match,
    enter: enter,
    is: is
  };
};

export { createStateMachine };
